module.exports = __webpack_public_path__ + "static/media/6-ContactoconCliente.83da8e0e.jpg";